import React from "react";
import BuyStocksImage from "../../../../images/titles/buy-stocks.svg";
import SellStocksImage from "../../../../images/titles/sell-stocks.svg";
import { useAuth } from "../../../../hooks/useAuth";
import { Button } from "@mui/material";

function ChangeButton({ isBuyMode, handleToggleMode }) {
  const { user } = useAuth();

  return (
    <div
      className="maxWidth marginAuto"
      style={{ display: "flex", alignItems: "center" }}
    >
      <h1>
        {isBuyMode === true ? (
          <img className="titleImage" src={BuyStocksImage} alt="Buy Stocks" />
        ) : (
          <img className="titleImage" src={SellStocksImage} alt="Sell Stocks" />
        )}
      </h1>
      <div className="separatorVerticalEmptySmall"></div>
      <div style={{ flex: 1 }}>
        {user.usertype === "buyerandseller"  && (
          <Button
            onClick={handleToggleMode}
            sx={{
              typography: "caption",
              fontWeight: "500",
              textDecoration: "underline",
            }}
          >
            Change to {isBuyMode ? "Sell" : "Buy"}
          </Button>
        )}
      </div>
    </div>
  );
}

export default ChangeButton;
